import { device } from "components/styles";
import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <FooterContainer>
      <div>사업자등록번호: 405-86-03017 ㅣ (주)다이아오션</div>
      <div>통신판매업신고번호: 제 2024-경기하남-2487호</div>
      <div>(12999) 경기도 하남시 감일중앙로 60, 4F ㅣ 대표: 장성주</div>
      <div>Tel: 02-487-5570 | Fax: 02-487-5571 </div>
      <div>Email: admin@diaoceanlnc.com</div>
      <div>Copyright © DIAOCEAN lnc. All rights reserved.</div>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5rem 4.4rem;
  box-sizing: border-box;
  // border-top: 1px solid #e8ecf2;
  gap: 0.5rem;
  color: #757c86;
  line-height: 150%;
  font-size: 1.2rem;
  background-color: #fff;
  width: 100vw;
  // width: calc(100vw - 320px);
  // margin-left: 320px;

  @media all and (${device.mobile}) {
    padding: 2.5rem 1.6rem 12rem;
    margin-left: 0;
    width: 100%;
  }
`;
